import React from 'react'
import FooterAccountSignupClient from './footer-account-signup-client'

type Props = {
  siteUrl: string
  translate: (arg: string) => string
}
export const FooterAccountSignup = ({ siteUrl, translate }: Props) => (
  <div className="content-area-input u-mb-32 u-mb-md-0">
    <p className="h2 u-color-gray-02 d-flex flex-row u-mr-12 u-mb-16 u-mb-md-24">
      {translate('CreateBusinessAccount')}
    </p>
    <p className="u-fs-16 u-color-gray-02">{translate('AccountAdvantages')}</p>
    <ul className="u-color-gray-02 u-fs-14 content-area-input--list-usp u-pt-0">
      <li>{translate('RegisterBuinsess_Usp_One')}</li>
      <li>{translate('RegisterBuinsess_Usp_Two')}</li>
      <li>{translate('RegisterBuinsess_Usp_Three')}</li>
    </ul>
    <a
      href={`${siteUrl}/registration`}
      className="c-footer--account-btn u-py-12 u-px-40 u-bg-gray-02 u-color-black u-decoration-none u-fs-14 u-radius-2">
      {translate('CreateBusinessAccount2')}
    </a>
  </div>
)

export default FooterAccountSignupClient
